import InputField, {
    InputNumberField,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { TextCapitalize } from '../../../../../utils/TextFormatter';

function AddPpuType({ formData, handleChange, update = false }) {
    return (
        <div className="flex flex-col gap-y-3 mb-4">
            {update ? (
                <InputField
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    disabled
                    required
                />
            ) : (
                <SelectOption
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    options={['thb', 'usd', 'eur', 'bdt']?.map((item) =>
                        addOption(item, item?.toUpperCase(), item)
                    )}
                    required
                />
            )}

            <InputNumberField
                label="PPU Limit"
                name="LimitByValue"
                placeholder="Type Limit By PPU..."
                formData={formData}
                onChange={handleChange}
                type="number"
                required
            />
            <div className="flex gap-3">
                <InputNumberField
                    label="Amount"
                    name="Amount"
                    placeholder="Type Amount..."
                    formData={formData}
                    onChange={handleChange}
                    type="number"
                    required
                />
                <InputNumberField
                    label="Vat(%)"
                    name="VatPercent"
                    placeholder="Type Vat(%)..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>
            {update && (
                <SelectOption
                    label="Status"
                    name="Status"
                    formData={formData}
                    onChange={handleChange}
                    options={['active', 'inactive']?.map((item) =>
                        addOption(item, TextCapitalize(item), item)
                    )}
                />
            )}
        </div>
    );
}

export default AddPpuType;
